import React from 'react';
import PropTypes from 'prop-types';
import UserLink from 'src/modules/shared/links/userLink';
import signupContext from 'src/constants/signupContext';
import linkUtils from 'src/utils/linkUtils';
import Badge from 'src/components/badges/badge';

const SupportingMembersList = ({ isLoggedIn, supportingMembers }) => {
  return (
    <div className="community-about__supporting-members-list">
      {
        supportingMembers.map(user => {
          const { username, userImageHash, role } = user;
          return (
            <div className="community-about__supporting-members-list__item" key={username}>
              <div className="community-about__supporting-members-list__avatar">
                <UserLink
                  avatar={true}
                  avatarSize="small"
                  isLoggedIn={!!isLoggedIn}
                  signupContext={{
                    element: signupContext.element.AVATAR,
                    section: signupContext.section.COMMUNITY_ABOUT,
                  }}
                  user={{
                    username,
                    avatar: linkUtils.generateAvatarLinkFromHash(userImageHash),
                  }}
                />
              </div>
              <div className="community-about__supporting-members-list__user">
                <UserLink
                  className="community-about__supporting-members-list__user-link"
                  isLoggedIn={!!isLoggedIn}
                  signupContext={{
                    element: signupContext.element.USER_LINK,
                    section: signupContext.section.COMMUNITY_ABOUT,
                  }}
                  user={{username}}
                />
                <Badge
                  content={role}
                  key="user-link-badge"
                />
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

SupportingMembersList.propTypes = {
  supportingMembers: PropTypes.array.isRequired,
  isLoggedIn: PropTypes.bool,
};

SupportingMembersList.defaultProps = {
  isLoggedIn: false,
};

export default SupportingMembersList;
